export var Spacing;
(function (Spacing) {
    Spacing["NONE"] = "0px";
    Spacing["EIGHTH"] = "2px";
    Spacing["QUARTER"] = "4px";
    Spacing["HALF"] = "8px";
    Spacing["THREE_QUARTERS"] = "12px";
    Spacing["SINGLE"] = "16px";
    Spacing["SINGLE_QUARTER"] = "20px";
    Spacing["SINGLE_HALF"] = "24px";
    Spacing["SINGLE_THREE_QUARTERS"] = "28px";
    Spacing["DOUBLE"] = "32px";
    Spacing["DOUBLE_QUARTER"] = "36px";
    Spacing["DOUBLE_HALF"] = "40px";
    Spacing["DOUBLE_THREE_QUARTERS"] = "44px";
    Spacing["TRIPLE"] = "48px";
    Spacing["TRIPLE_HALF"] = "56px";
    Spacing["QUADRUPLE"] = "64px";
    Spacing["QUINTUPLE"] = "80px";
    Spacing["OCTUPLE"] = "128px";
})(Spacing || (Spacing = {}));
export const getSpacingMultiple = (multiple) => `${16 * multiple}px`;
//# sourceMappingURL=spacing.js.map